import {createReducer} from "redux-act";
import {
	handleModalState,
	hideFanFact,
	showFanFact,
} from "apps/DRAW_PREDICTOR/modules/actions/modals";

export interface IModals {
	supportedCountries: boolean;
	fanSentiments: boolean;
	drawConfirmation: boolean;
	showEditPickModal: boolean;
	showEditPickLiteModal: boolean;
	tour: boolean;
	fanFactSquad: number;
	registration: boolean;
}

const initial: IModals = {
	supportedCountries: false,
	fanSentiments: false,
	drawConfirmation: false,
	showEditPickModal: false,
	showEditPickLiteModal: false,
	tour: false,
	fanFactSquad: 0,
	registration: false,
};

export const modals = createReducer({}, initial)
	.on(handleModalState, (state, payload) => ({
		...state,
		...payload,
	}))
	.on(showFanFact, (state, payload) => ({
		...state,
		fanFactSquad: payload,
	}))
	.on(hideFanFact, (state) => ({
		...state,
		fanFactSquad: 0,
	}));
